import { appConfig } from './app'

const main = window.origin
const url = new URL(window.origin)

export const urlsConfig = {
  landing: main,
  termsAndConditions: main + '/docs/terms-of-use',
  privacyPolicy: main + '/docs/privacy-policy',
  cookiePolicy: main + '/docs/cookie-policy',
  buy:
    process.env.REACT_APP_PAY_URL ||
    `${url.protocol}//pay${appConfig.appEnv === 'development' ? '-' : '.'}${url.host}`,
}
